import React from 'react';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { StandoutTile } from 'web-ui-components/lib/layout/content';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Submit from '../../components/Submit';
import LinkCode from '../../components/LinkCode';

const IncorrectLinkCodePage = ({
  saveEnterLinkCodeForm,
  linkCodeError,
  customerData,
  getBusinessData
}) => (
  <Form
    onSubmit={v => saveEnterLinkCodeForm(v, customerData)}
    initialValues={getBusinessData}
    render={({ handleSubmit }) => (
      <form onSubmit={handleSubmit}>
        <div>
          <Content>
            {({ inccorrectLinkCodeTitle, inccorrectLinkCodeDescription, enterLinkCodeSubmit }) => (
              <StandardBody>
                <PageHeading>{inccorrectLinkCodeTitle}</PageHeading>
                <p>{inccorrectLinkCodeDescription}</p>
                <LinkCode />
                {linkCodeError && (
                  <StandoutTile.Important>
                    <p>{linkCodeError}</p>
                  </StandoutTile.Important>
                )}
                <Submit submitButtonText={enterLinkCodeSubmit} />
              </StandardBody>
            )}
          </Content>
        </div>
      </form>
    )}
  />
);

IncorrectLinkCodePage.propTypes = {
  saveEnterLinkCodeForm: PropTypes.func.isRequired
};

export default IncorrectLinkCodePage;
